/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.MilesOrKilometers = (function () {

    function MilesOrKilometers () {

        Monet.UI.Fields.Distance.apply (this, arguments);

        //Campos em miles e km devem exibir 2 casas decimais
        this.precision = 2;

        this.getValue = function () {

            if (this.input && this.input.value) {

                var valueToReturn = this.input.value;
                this.value = this.convertToMetricSystem(valueToReturn);

            }

            return this.value;
        };

        this.setValue = function (value) {

            this.value = value || this.value;
            this.setInputValue();

        };

        this.setInputValue = function () {

            if (this.value && this.input) {

                var value = this.convertToUserMetricSystem(this.value);
                this.input.value = value;

            }

        };

        this.convertToMetricSystem = function (value) {

            var valueToConvert = value || 0;
            var formatter = new Monet.Format.MILES_OR_KM(valueToConvert);

            formatter.parseFloat();

            if (Monet.Session.User.unitSystem === "NON_METRIC") {

                formatter.convertMilesToKm();

            }

            return formatter.getValue();

        };

        this.convertToUserMetricSystem = function (value) {

            var valueToConvert = value || 0;
            var formatter = new Monet.Format.MILES_OR_KM(valueToConvert);

            if (Monet.Session.User.unitSystem === "NON_METRIC") {

                formatter.convertKmToMiles();

            } else if (typeof valueToConvert === 'string') {

                formatter.parseFloat();

            }

            return formatter.setPrecision(this.precision).formatWithoutSeparatorThousands().getValue();

        };

        this.setMaxSize = function (maxSize) {

            this.maxSize = maxSize;

        };

        this.getMaxSize = function () {

            return this.maxSize;

        };

        this.createElement = function () {

            this.input = document.createElement('input');

            this.input.type = 'text';
            this.input.className = 'mileOrKmField';

            if(this.getMaxSize()){
                this.input.maxLength = this.maxSize;
            }

            this.rootEl.appendChild(this.input);

        };

        this.render = function () {

            this.createElement();
            this.addEventListeners();
            this.setInputValue();
            return this.rootEl;

        };

    }

    return MilesOrKilometers;

}());